const APPLE_PAY_RECURRING_MESSAGE = 'This amount is only an estimate.';
const APPLE_PAY_MANAGEMENT_URL = 'https://payments.xfinity.com';

const getAppleRecurringPaymentRequest = ({ billingAmount, recurringPaymentStartDate }) => {
  const regularBilling = {
    amount: billingAmount,
    label: 'Estimated Upcoming Charges',
    paymentTiming: 'recurring',
    ...(recurringPaymentStartDate && { recurringPaymentStartDate }),
  };

  return {
    // https://developer.apple.com/documentation/applepayontheweb/applepaypaymentrequest/lineitems
    // A set of line items that explain recurring payments and additional charges and discounts.
    lineItems: [regularBilling],
    // https://developer.apple.com/documentation/applepayontheweb/applepaypaymentrequest/recurringpaymentrequest
    recurringPaymentRequest: {
      regularBilling,
      paymentDescription: APPLE_PAY_RECURRING_MESSAGE,
      billingAgreement: APPLE_PAY_RECURRING_MESSAGE,
      managementURL: APPLE_PAY_MANAGEMENT_URL,
    },
  };
};

// Creates Apple Pay payload fields required by CPC
export const getApplePayDetailsForCpc = regularBilling => ({
  displayBusinessName: 'Xfinity',
  sessionType: 'web',
  ...(regularBilling && {
    enableRecurringPayment: true,
    recurringPaymentDetails: {
      autoPayManagementURL: APPLE_PAY_MANAGEMENT_URL,
      paymentDescription: APPLE_PAY_RECURRING_MESSAGE,
      regularBilling,
    },
  }),
});

/**
 * @param {string} amount - The amount to show on the payment sheet.
 * @param {Object} [data] - Optional data for recurring payments.
 * @param {'pending' | 'final'} data.type - Shows 'Amount pending' or the amount.
 * @param {string} data.billingAmount - The amount for recurring payments.
 * @param {string} [data.recurringPaymentStartDate] -
 *  Optional date to show for when the recurring payment begins.
 *  Shows 'Starting now' if a date isn't provided.

 * @see https://developer.apple.com/documentation/applepayontheweb/applepaypaymentrequest
 */
export const getApplePaymentRequest = (amount, data) => ({
  currencyCode: 'USD',
  countryCode: 'US',
  merchantCapabilities: ['supports3DS'],
  supportedNetworks: ['amex', 'masterCard', 'visa'],
  total: {
    label: 'Comcast',
    amount: amount || 1.00,
    ...(data && { type: data.type }),
  },
  requiredBillingContactFields: ['name', 'postalAddress', 'phone'],
  ...(data && getAppleRecurringPaymentRequest(data)),
});

export default getApplePaymentRequest;
